import React, { forwardRef } from "react";
import styles from "./styles/InputPhone.module.css";
/**
 * Inpur text component
 * ForwardRef is used to focus on the element when mounted since it is a component
 */
const InputPhone = forwardRef(
    (
        {
            label,
            inputId,
            inputValue,
            handleChangeFunction,
            handleKeyDownFunction,

            handleBlur,
            required,
            placeholder,
            letterSpacing,
            textAlign,
            maxLength,

            data,
            disable,
            adaptFont,
            fullWidth,
        },
        ref
    ) => {
        return (
            <div
                className={`${styles.input_container} ${
                    fullWidth ? styles.full_width : ""
                } v-flex-container`}
            >
                <label className={`${styles.input_label}`} htmlFor={inputId}>
                    {label}
                    {label ? ":" : ""}
                </label>
                <input
                    ref={ref}
                    data-ex={data && data}
                    className={`${styles.input_element} ${
                        required && styles.alert
                    } ${disable ? styles.disabled : ""}  ${
                        adaptFont ? styles.adaptFont : ""
                    }`}
                    style={{
                        letterSpacing: letterSpacing,
                        textAlign: textAlign,
                    }}
                    type={"number"}
                    name={inputId}
                    id={inputId}
                    value={inputValue ?? ""}
                    placeholder={required ? placeholder : ""}
                    onChange={handleChangeFunction && handleChangeFunction}
                    onKeyDown={handleKeyDownFunction && handleKeyDownFunction}
                    maxLength={maxLength}
                    spellCheck={false}
                    autoComplete={"off"}
                    disabled={disable}
                    onBlur={handleBlur}
                />
            </div>
        );
    }
);

export default InputPhone;
